import clsx from 'clsx';
import React from 'react';
import styles from './Alert.module.scss';
const defaultIconMapping = {
    success: 'https://www.haven.com/assets/owners/shared/tick.svg',
    warning: 'https://www.haven.com/assets/owners/shared/warning.svg',
    error: 'https://www.haven.com/assets/owners/shared/warning.svg',
    info: 'https://www.haven.com/assets/owners/shared/warning.svg',
};
/**
 * @deprecated This component is deprecated and will be removed in a future release. Use V2 Alert instead.
 */
export const Alert = ({ severity, children, icon = null, className = null, }) => (<div className={clsx(styles.root, styles[severity], className)}>
    <div className={styles.icon}>
      {icon ? icon : <img src={defaultIconMapping[severity]} alt='' role='presentation'/>}
    </div>
    <div className={styles.content}>{children}</div>
  </div>);
